export default __webpack_public_path__ + "987b66cbc00815e2d42ce318da809669.svg";